import React from 'react';

interface IOpacityIconProps {
  style?: any;
}

export const OpacityIcon:React.FC<IOpacityIconProps> = (props: IOpacityIconProps) => {
  return (
    <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.40003 0.632812H0V4.03285H3.40003V0.632812Z" fill="#CCCCCC"/>
      <path d="M10.1998 0.632812H6.7998V4.03285H10.1998V0.632812Z" fill="#CCCCCC" fillOpacity="0.8"/>
      <path d="M13.6002 4.03125H10.2002V7.43128H13.6002V4.03125Z" fill="#CCCCCC" fillOpacity="0.65"/>
      <path d="M6.80029 4.03125H3.40015V7.43128H6.80029V4.03125Z" fill="#CCCCCC" fillOpacity="0.9"/>
      <path d="M17.0004 0.632812H13.6003V4.03285H17.0004V0.632812Z" fill="#CCCCCC" fillOpacity="0.5"/>
      <path d="M3.40003 7.43359H0V10.8336H3.40003V7.43359Z" fill="#CCCCCC"/>
      <path d="M10.1998 7.43359H6.7998V10.8336H10.1998V7.43359Z" fill="#CCCCCC" fillOpacity="0.8"/>
      <path d="M13.6002 10.832H10.2002V14.2321H13.6002V10.832Z" fill="#CCCCCC" fillOpacity="0.65"/>
      <path d="M6.80029 10.832H3.40015V14.2321H6.80029V10.832Z" fill="#CCCCCC" fillOpacity="0.9"/>
      <path d="M17.0004 7.43359H13.6003V10.8336H17.0004V7.43359Z" fill="#CCCCCC" fillOpacity="0.5"/>
      <path d="M3.40003 14.2344H0V17.6344H3.40003V14.2344Z" fill="#CCCCCC"/>
      <path d="M10.1998 14.2344H6.7998V17.6344H10.1998V14.2344Z" fill="#CCCCCC" fillOpacity="0.8"/>
      <path d="M17.0004 14.2344H13.6003V17.6344H17.0004V14.2344Z" fill="#CCCCCC" fillOpacity="0.5"/>
    </svg>
  )
}